var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',{attrs:{"dismissRoute":'/staff/vendors/' + _vm.id}},[_c('div',{staticClass:"drawer-title"},[_c('i',{staticClass:"mat-icon"},[_vm._v("mode_edit")]),_vm._v("Edit Address")]),_c('address-builder',{attrs:{"displaySave":true,"loading":_vm.loading,"base-data":_vm.address,"has-notes":true},on:{"saveClick":_vm.saveAddress}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4aa992","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/staff/VendorEditAddress.vue
// module id = 670
// module chunks = 0